/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Totals across the workshops of a report.
 * 
 * Attendance counts are summed over attendance rows; `students` and `students_checked_in`
 * count each user once across all the workshops.
 * @export
 * @interface AttendanceReportTotals
 */
export interface AttendanceReportTotals {
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    workshops?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    registered?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    checked_in?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    absent?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    excused?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    students?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    students_checked_in?: number;
    /**
     * 
     * @type {number}
     * @memberof AttendanceReportTotals
     */
    submissions?: number;
}

/**
 * Check if a given object implements the AttendanceReportTotals interface.
 */
export function instanceOfAttendanceReportTotals(value: object): value is AttendanceReportTotals {
    return true;
}

export function AttendanceReportTotalsFromJSON(json: any): AttendanceReportTotals {
    return AttendanceReportTotalsFromJSONTyped(json, false);
}

export function AttendanceReportTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceReportTotals {
    if (json == null) {
        return json;
    }
    return {
        
        'workshops': json['workshops'] == null ? undefined : json['workshops'],
        'registered': json['registered'] == null ? undefined : json['registered'],
        'checked_in': json['checked_in'] == null ? undefined : json['checked_in'],
        'absent': json['absent'] == null ? undefined : json['absent'],
        'excused': json['excused'] == null ? undefined : json['excused'],
        'students': json['students'] == null ? undefined : json['students'],
        'students_checked_in': json['students_checked_in'] == null ? undefined : json['students_checked_in'],
        'submissions': json['submissions'] == null ? undefined : json['submissions'],
    };
}

export function AttendanceReportTotalsToJSON(json: any): AttendanceReportTotals {
    return AttendanceReportTotalsToJSONTyped(json, false);
}

export function AttendanceReportTotalsToJSONTyped(value?: AttendanceReportTotals | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshops': value['workshops'],
        'registered': value['registered'],
        'checked_in': value['checked_in'],
        'absent': value['absent'],
        'excused': value['excused'],
        'students': value['students'],
        'students_checked_in': value['students_checked_in'],
        'submissions': value['submissions'],
    };
}

